import { render, staticRenderFns } from "./ProjectQuestionnaireReview.vue?vue&type=template&id=63b24fd3&"
import script from "./ProjectQuestionnaireReview.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionnaireReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports